<template>
    <div class="el-tabs">
        <el-radio-group class="el-radio-group" v-model="activeName" @change="radioChange">
            <el-radio-button v-for="(radioButtonTitle,index) in radioButtonTitles" :label="index+1" :key="index">
                {{radioButtonTitle}}
            </el-radio-button>
        </el-radio-group>
        <el-button class="keyword-reply-plus" type="primary" @click="addMessageClick" icon="el-icon-plus"/>
        <el-table
                border
                stripe
                height="450"
                :data="tableData"
                v-loading="loading.table"
                :header-cell-style="{'background':'#e0e1e4','color':'#555'}"
                style="width: 100%">
            <div v-for="(item,index) in tableNames" :key="index">
                <el-table-column v-if="item.prop !=='isEnable'"
                                 :prop="item.prop"
                                 :label="item.name"
                                 :fixed="item.fixed"
                                 :formatter="formatter"
                                 show-overflow-tooltip
                                 :width="index === 0 ? 50 : 160"/>
                <el-table-column v-if="item.prop ==='isEnable'"
                                 :prop="item.prop"
                                 :label="item.name"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 width="150">
                    <template slot-scope="scope">
                        <el-switch
                                v-model="scope.row.isEnable"
                                :active-value="1"
                                :inactive-value="0"
                                active-color="#13ce66"
                                @change="handleEnable(scope.row,scope.$index)"
                                inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
            </div>
        </el-table>
        <AddKeyWordMessageReply :show.sync="addMessageShow"
                                :titleName="radioButtonTitles[activeName-1]"
                                :msgAction="activeName"
                                @handleClose="handleClose"></AddKeyWordMessageReply>
    </div>
</template>

<script>
    import AddKeyWordMessageReply from "../components/AddKeyWordMessageReply";
    import {MessageReplyConfig} from './conf/index'

    export default {
        name: "MessageReply",
        components: {
            AddKeyWordMessageReply
        },
        data() {
            return {
                tableNames: MessageReplyConfig.tableNames,
                activeName: 1,
                radioButtonTitles: ["关键词回复", "被关注回复", "点击回复"],
                addMessageShow: false,
                tabNames: [],
                loading: {
                    table: false
                },
                tableData: [],
                state: true
            }
        },
        methods: {
            messages() {
                this.loading.table = true;
                let param = {
                    msgAction: this.activeName
                };
                this.$api.messageReply.messages(param).then((data) => {
                    this.tableData = data.data;
                    this.loading.table = false;
                });
            },
            addMessageClick() {
                window.console.log(this.addMessageShow);
                this.addMessageShow = true;
            },
            formatter(row, column, cellValue) {
                if (!cellValue) {
                    return "-";
                } else {
                    return cellValue;
                }
            },
            handleEnable(row) {
                let body = {
                    id: row.id,
                    isEnable: row.isEnable,
                    msgAction: this.activeName
                };
                row.isEnable = !row.isEnable;
                this.$api.messageReply.messageEnable(body).then((data) => {
                    if (data.code === "0000") {
                        this.$message({
                            message: "更新成功",
                            type: "success",
                        });
                        this.messages();
                    } else {
                        this.$message({
                            showClose: true,
                            message: data.message,
                            type: "error"
                        });
                    }
                })
            },
            radioChange(val) {
                this.activeName = val;
                this.messages();
                window.console.log("activeName", this.activeName)
            },
            handleClose() {
                this.messages();
            }
        },
        mounted() {
            this.messages();
            window.console.log(this.tableNames)
        }
    }
</script>

<style scoped>
    .el-tabs {
        margin: 20px 0 0 20px;
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        padding: 20px 10px;
        height: 500px;
        width: 1161px;
    }

    .keyword-reply-plus {
        float: right;
        margin-bottom: 10px;
    }

    .el-radio-group {
        float: left;
    }
</style>